var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg66(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 1.34734C29.1406 3.28094 27.207 6.7575 27.207 10.4294C27.207 12.363 27.9883 14.2966 28.9453 16.0348C29.7266 17.5778 30.0977 20.2927 27.4023 21.6403C25.4883 22.7927 22.9688 22.0309 21.8164 20.0973C20.6641 18.5544 19.3164 17.0114 17.5781 15.8591C14.2969 13.9255 10.4492 13.9255 7.16797 15.8591C3.88672 17.7927 1.95312 21.2692 1.95312 24.9606C1.95312 28.652 3.86719 32.1286 7.16797 34.0622C10.4492 35.9958 14.2969 35.9958 17.5781 34.0622C19.3164 33.0856 20.6641 31.5427 21.6211 29.8044C22.4023 28.4567 24.5117 26.6989 27.207 28.2614C29.1211 29.4137 29.707 31.9333 28.75 33.8669C27.793 35.6052 27.207 37.5388 27.207 39.4723C27.207 43.1442 29.1211 46.6403 32.4219 48.5544C35.7031 50.488 39.5508 50.488 42.832 48.5544C46.1133 46.6208 48.0469 43.1442 48.0469 39.4528C48.0469 35.7614 46.1133 32.2848 42.832 30.3512C41.0938 29.3747 39.1602 29.0036 37.0508 29.0036C35.3125 29.0036 33.0078 27.8512 33.0078 24.9411C33.0078 22.6169 34.7461 20.8786 37.0508 20.8786C38.9648 20.8786 41.0938 20.488 42.832 19.5309C46.1133 17.5973 48.0469 14.1208 48.0469 10.4489C48.0469 6.77703 46.1133 3.28094 42.832 1.36688C41.2891 0.390313 39.375 -0.000312094 37.6172 -0.000312094C35.8984 -0.0198433 33.9648 0.390313 32.4219 1.34734Z",
    fill: "url(#paint0_linear_2460_2753)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2753",
    x1: 1.95312,
    y1: 24.9997,
    x2: 48.0469,
    y2: 24.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0880B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg66);
export default __webpack_public_path__ + "static/media/66.e41e5d25fc0133cb6f4b83ba6cd5d5f3.svg";
export { ForwardRef as ReactComponent };